const defaultSettings = {
  title: "AlessiPlatform",
  // theme: "light",
  ADMIN_ROLE: "ROLE_ADMIN"
}


export default defaultSettings;
